import * as Sentry from '@sentry/react'

if (
    import.meta.env.VITE_ENABLE_SENTRY === 'true' &&
    import.meta.env.VITE_APP_ENV &&
    import.meta.env.VITE_APP_ENV !== 'local'
) {
    Sentry.init({
        dsn: 'https://6e0f3caeb71b7d5b830810ff845ed89a@o4508493791494144.ingest.us.sentry.io/4508494044659712',
        integrations: [
            Sentry.browserTracingIntegration(),
            Sentry.replayIntegration(),
        ],
        environment: import.meta.env.VITE_APP_ENV as string,
        tracesSampleRate: 1.0,
        tracePropagationTargets: [],
        replaysSessionSampleRate: 1.0,
        replaysOnErrorSampleRate: 1.0,
    })
}
